enum PlaylistTypes {
  Default = 'default',
  New4U = 'new4u',
  User = 'user',
}

export default PlaylistTypes;
